import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";

import { CancelBenefit, BenefitTotal, CancelRequestItems } from "src/app/models/benefit-summary";
import { TableColumn } from "src/app/models/table";
 

@Component({
    selector: 'mwp-benefit-enrollment-wizard-request-term',
    templateUrl: './request-term.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RequestTermComponent implements OnInit {
    @Input() public cancelBenefit: CancelBenefit;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();
    
    public showSummary: boolean;
    public cancelBenefitData = new MatTableDataSource<CancelRequestItems>();
    public showSummaryTotal: boolean;
    public benefitTotal = new BenefitTotal();
    

    public cancelBenefitColumns: TableColumn[] = [
		{
			columnName: 'Benefit',
			propertyId  : 'benefitName',
            columnType: TableColumnType.label,
		},
		{
			columnName: 'Date Request Made',
			propertyId  : 'requestDate',
            columnType: TableColumnType.label,
		},
		{
			columnName: 'Process',
			propertyId  : 'process',
            columnType: TableColumnType.label,
		},
	];

    ngOnInit(){
        this.cancelBenefitData.data = this.cancelBenefit.cancelRequestItems;
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitTermComplete() {
        this.emitComplete.emit();
    }
}